import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  data: [],
  addData: {},
};

const slice = createSlice({
  name: 'RecruitmentJobPosts',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getJobPostsSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateJobPosts(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getJobPosts() {
  return async () => {
    try {
      const response = await get('recruitment/jobPosts');
      if (response.status) {
        dispatch(slice.actions.getJobPostsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addJobPost(body) {
  return async () => {
    try {
      const response = await post('recruitment/jobPosts', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateJobPosts(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateJobPost(body) {
  return async () => {
    try {
      const response = await put('recruitment/jobPosts', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateJobPosts(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
